import React, { useEffect, useState } from 'react';

import { Grid, Container, Typography, makeStyles, Link } from '@material-ui/core';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { filter } from 'rxjs/operators';

import DowngradeStudyList from '../../components/downgradeStudyList/DowngradeStudyList';
import useBlocRef from '../../utils/useBlocRef.hook';

const useStyles = makeStyles((theme) => {
  return {
    container2: {
      color: '#999999',
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '30px',
      paddingTop: '30px',
    },
    description: {
      color: '#999999',
      fontSize: '16px',
      lineHeight: '28px',
      marginBottom: '2rem',
    },
    packagePopular: {
      color: theme.palette.primary.main,
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '122%',
    },
  };
});
export default () => {
  const blocRef = useBlocRef('downgradeBloc');
  const history = useHistory();
  const classes = useStyles();
  const [studies, setStudies] = useState([]);
  const [planCount] = useState(blocRef.current.planCount);

  useEffect(() => {
    blocRef.current.getDowngradeRecords();
    const studiesSub = blocRef.current.records$.pipe(filter((e) => e)).subscribe(setStudies);
    return () => {
      studiesSub.unsubscribe();
    };
  }, []);

  const handleContinue = (checkedStudies) => {
    if (checkedStudies.length === 0) {
      blocRef.current.confirmNoSelection();
    } else {
      blocRef.current.setStudiesToRemove(checkedStudies);
      history.push('/confirm-downgrade');
    }
  };
  return (
    <Grid container component={Container} style={{ display: 'flex' }} className="pt-2 pb-2">
      <Grid item xs={12} style={{ padding: '0 25%' }}>
        <Typography className="page-header mb-1"> Before we get started</Typography>
      </Grid>
      <Grid item xs={12} style={{ padding: '0 25%' }}>
        <Typography className={classes.description}>
          We have noticed that the amount of files you have stored on your personal medical record exceeds the total amount of storage you have requested.
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ padding: '0 25%' }}>
        <Typography className="secondary-header mb-2">Please select the files you have on record that you would like to retain with your new subscription plan.</Typography>
        <Typography className="secondary-header mb-2">
          Please note that any cases that have a video report in progress will have to remain in the system until the video is completed.
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ padding: '0 25%' }}>
        <DowngradeStudyList studies={studies} planCount={planCount} onContinue={handleContinue} />
      </Grid>

      <Grid item xs={12} style={{ padding: '0 25%' }}>
        <Container className={classes.container2}>
          Need more storage?{' '}
          <Link component={RouterLink} className={classes.packagePopular} to="/package-plans" style={{ fontSize: '20px' }}>
            Click here to upgrade your plan
          </Link>
        </Container>
      </Grid>
    </Grid>
  );
};
